import { SLASH_COMMANDS } from 'content-assistance-lib/autocomplete/commands';
import { SELECTION_COMMANDS } from 'content-assistance-lib/toolbars/commands';
import { isLegacyObjectType } from 'rich-text-lib/utils/properties';
import { AsyncContentAssistanceAutocomplete, AsyncContentAssistanceToolbar } from 'automation-ui-action-features/pickers/asyncPickers';
export const adjustFqnCasing = propertyObjectFQN => {
  // TinyMCE no longer messes with FQN casing. However, we're defining and/or
  // fetching legacy object type FQNs in CAPS, so we need to lowercase them
  return isLegacyObjectType(propertyObjectFQN) ? propertyObjectFQN.toLowerCase() : propertyObjectFQN;
};
export const getContentAssistConfigOptions = ({
  isContentAssistanceEnabled
}) => {
  return isContentAssistanceEnabled ? {
    useCopilotCollaboration: true,
    hsContentAssistant: {
      selectionCommands: [SELECTION_COMMANDS.MARKETING_EMAIL_REPHRASE_V2, SELECTION_COMMANDS.MARKETING_EMAIL_EXPAND_IDEA_V2, SELECTION_COMMANDS.MARKETING_EMAIL_SUMMARIZE_IDEA_V2, SELECTION_COMMANDS.MARKETING_EMAIL_CHANGE_TONE_V2],
      slashCommands: [SLASH_COMMANDS.EMAIL_PARAGRAPH_V2, SLASH_COMMANDS.EMAIL_HEADING_V2]
    }
  } : {};
};
export const getContentAssistPickers = ({
  isContentAssistanceEnabled
}) => {
  return isContentAssistanceEnabled ? {
    ContentAssistantAutocompleteMenu: AsyncContentAssistanceAutocomplete,
    ContentAssistanceToolbar: AsyncContentAssistanceToolbar
  } : {};
};